import React from 'react';

import AppLogger from 'utils/AppLogger';

import { ErrorPageContent } from './ErrorPage';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error: error.message };
	}

	componentDidCatch(error, errorInfo) {
		AppLogger.error('ErrorBoundary', error, errorInfo);

		// check if error is chunk load error
		if (error.message.includes('Loading chunk')) {
			// if chunk load error, reload the page
			window.location.reload();
		}
	}

	render() {
		if (this.state.hasError) {
			return <ErrorPageContent />;
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
